import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AdvancedCommerceListingAdvertComponentDef } from '@df/module-advanced-commerce';
import { ImageModule } from '@df/module-image/image.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { ShellComponent } from '@df/ui/common/shell/shell.component';

export enum EAdvertType {
    default = 'default',
    trending = 'trending'
}

@Component({
    selector: 'advanced-commerce-listing-advert',
    templateUrl: './advanced-commerce-listing-advert.html',
    standalone: true,
    imports: [HrefComponent, NgClass, ShellComponent, ImageModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedCommerceListingAdvertComponent extends AdvancedCommerceListingAdvertComponentDef {
    readonly EAdvertType = EAdvertType;

    get image(): string | undefined {
        return this.item().image || undefined;
    }

    get type(): string {
        return this.item().advert_type === EAdvertType.trending ? EAdvertType.trending : EAdvertType.default;
    }
}
